import { render, staticRenderFns } from "./invoiceList.vue?vue&type=template&id=3b20cb92&scoped=true&"
import script from "./invoiceList.vue?vue&type=script&lang=js&"
export * from "./invoiceList.vue?vue&type=script&lang=js&"
import style0 from "./invoiceList.vue?vue&type=style&index=0&id=3b20cb92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b20cb92",
  null
  
)

export default component.exports